var events = require('events');

var eventEmitter = new events.EventEmitter();
var regex = /\w+-\w+-\w+/;
var QSendNotification = {
  /**
   * 发送广播
   * @param name 广播的标识 必须是 部门-业务-功能 这种格式的，例如：flight-booking-detail
   * @param data 发送的广播数据
   * @param errorCallback
   **/
  sendNotification: function sendNotification(_ref) {
    var name = _ref.name,
        data = _ref.data,
        errorCallback = _ref.errorCallback;
    var OK = regex.test(name);

    if (!OK) {
      errorCallback({
        error: '请输入正确的name'
      });
      return;
    }

    eventEmitter.emit(name, data);
  },

  /* 监听广播
  * @param name 广播的标识 必须是 部门-业务-功能 这种格式的，例如：flight-booking-detail
  * @param subscriptionCallback 回调出去的subscription，用于移除相应的subscription监听使用
  * @param dataCallback 数据回调
  * @param errorCallback 当name不符合格式时给出的错误提示
  **/
  addNotification: function addNotification(_ref2) {
    var name = _ref2.name,
        subscriptionCallback = _ref2.subscriptionCallback,
        dataCallback = _ref2.dataCallback,
        errorCallback = _ref2.errorCallback;
    var OK = regex.test(name);

    if (!OK) {
      errorCallback({
        error: '请输入正确的name'
      });
      return;
    }

    eventEmitter.addListener(name, dataCallback); // @ts-ignore

    subscriptionCallback(dataCallback);
  },

  /* 移除监听广播
   * @param name 广播的标识 必须是 部门-业务-功能 这种格式的，例如：flight-booking-detail
   * @param subscription 从addNotification接口里拿到的subscription，用来正确移除这个监听
   * @param errorCallback 当name不符合格式时给出的错误提示
   **/
  removeNotification: function removeNotification(_ref3) {
    var name = _ref3.name,
        subscription = _ref3.subscription,
        errorCallback = _ref3.errorCallback;
    var OK = regex.test(name);

    if (!OK) {
      errorCallback({
        error: '请输入正确的name'
      });
      return;
    }

    if (subscription) {
      eventEmitter.removeListener(name, subscription);
    }
  }
};
export default QSendNotification;